import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { selectLoader, templateTitleLimit, validateTextInput } from '../utils/Helpers';
import boardToast from 'pages/projects/kanban/utils/boardToast';
import { TOAST_TYPE } from 'utils/AppToast';

const SaveModalKanban = ({
  show,
  onHide,
  isCreateBoard = false,
  onSave,
  title = '',
  onTitleChange,
  isLoading = false,
  isEditingBoard = false,
  isTemplate = false,
  isWorkspace = false
}) => {
  const [validationError, setValidationError] = React.useState('');
  const inputRef = React.useRef(null); // 👈 create ref

  useEffect(() => {
    if (show && inputRef.current) {
      inputRef.current.focus(); // 👈 focus when modal opens
    }
  }, [show]);
  const buttonStyle = {
    opacity: !title.trim() || isLoading ? 0.5 : 1,
    cursor: !title.trim() || isLoading ? 'not-allowed' : 'pointer'
  };

  const handleSave = () => {
    const validation = validateTextInput(title);
    if (!validation.isValid) {
      // setValidationError(validation.message);
      boardToast(validation.message, TOAST_TYPE.ERROR);
      return;
    }
    setValidationError('');
    onSave(validation.cleanedValue);
  };
  return (
    <div>
      <Modal
        show={show}
        onHide={() => {
          setValidationError('');
          onHide();
        }}
        dialogClassName=""
        centered
        className="deletModal create-board-modal">
        <Modal.Header closeButton={true}>
          <div class="modal-title">
             {isCreateBoard ? `${isEditingBoard ? 'Edit' : 'Create'} ${isWorkspace ? 'Workspace' : 'Board'}` : 'Save Template'}
          </div>
        </Modal.Header>
        <Modal.Body className="save-templete-cover">
          <div className="save-templete-box">
            <label> {isCreateBoard ? `${isWorkspace ? 'Workspace' : 'Board'} title*` : 'Template name*'}</label>
            <input
              ref={inputRef}
              type="text"
              placeholder={isCreateBoard ? `Write ${isWorkspace ? 'workspace' : 'board'} title` : 'Write template name'}
              className={`form-control ${validationError ? 'is-invalid' : ''}`}
              value={title}
              maxLength={templateTitleLimit}
              onChange={(e) => {
                onTitleChange(e.target.value);
                if (validationError) {
                  setValidationError('');
                }
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleSave();
                }
              }}
            />
            {validationError && <div className="invalid-feedback">{validationError}</div>}
          </div>
          <div className="save-templete-group-btn">
            <button
              className={`black-btn cursor_pointer ${!title.trim() || isLoading ? 'disabled-btn' : ''}`}
              onClick={handleSave}
              disabled={!title.trim() || isLoading}
              style={buttonStyle}>
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                </>
              ) : (
                'Save'
              )}
            </button>
            {/* <button className="black-btn">Save</button> */}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SaveModalKanban;
